/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import Layout from '../../components/Layout';
import Register from './Register';
import Messages from './Messages';

function action({intl}) {
  const messages = Messages();
  const title = intl.formatMessage({ ...messages.register_page_title_text });
  return {
    chunks: ['register'],
    title,
    component: (
      <Layout loggedOut>
        <Register title={title} />
      </Layout>
    ),
  };
}

export default action;



// WEBPACK FOOTER //
// ./src/routes/register/index.js